import { mergeStep } from '@/utils'
import { http } from '@/utils/http'

// 注册用户
export const registerUserAPI = (data) =>
  http({
    url: '/api/user/register',
    method: 'POST',
    data,
  })

// 登录
export const loginUserAPI = (data) =>
  http({
    url: '/api/user/login',
    method: 'POST',
    data,
  })

// 获取用户信息
export const getUserInfoAPI = () =>
  http({
    url: '/api/user/index',
    method: 'GET',
  })

// 退出登录
export const logoutUserAPI = () =>
  http({
    url: '/api/user/logout',
    method: 'POST',
  })

// 简介、公告、新闻
export const getIntroductionAPI = (data) =>
  http({
    url: '/api/index/articlelist',
    method: 'POST',
    data,
  })

// 新闻详情
export const getIntroductionDetailAPI = (data) =>
  http({
    url: '/api/index/articledetails',
    method: 'POST',
    data,
  })

// 投资理财列表
export const getInvestmentListAPI = (data) =>
  http({
    url: '/api/index/investlist',
    method: 'POST',
    data,
  })

// 提交投资
export const submitInvestAPI = (data) =>
  http({
    url: '/api/user/submitinvest',
    method: 'POST',
    data,
  })

// 获取投资记录
export const getInvestmentRecordAPI = (data) =>
  http({
    url: '/api/user/myinvestlist',
    method: 'POST',
    data,
  })

// 查询实名认证
export const getRealNameAuthAPI = mergeStep(() =>
  http({
    url: '/api/user/finduserauth',
    method: 'POST',
  }),
)

// 实名认证
export const realNameAuthAPI = (data) =>
  http({
    url: '/api/user/userauth',
    method: 'POST',
    data,
  })

// 我的邀请
export const getMyTeamAPI = (data) =>
  http({
    url: '/api/user/inviteelist',
    method: 'POST',
    data,
  })

// 我的资产
export const getMyAssetAPI = (data) =>
  http({
    url: '/api/user/moneyloglist',
    method: 'POST',
    data,
  })

// 股数转换
export const convertScoreAPI = (data) =>
  http({
    url: '/api/user/conversion',
    method: 'POST',
    data,
  })

// 添加银行卡
export const addBankCardAPI = (data) =>
  http({
    url: '/api/user/addbank',
    method: 'POST',
    data,
  })

// 获取银行卡
export const getBankCardAPI = (data) =>
  http({
    url: '/api/user/banklist',
    method: 'POST',
    data,
  })

// 删除银行卡
export const deleteBankCardAPI = (data) =>
  http({
    url: '/api/user/delbank',
    method: 'POST',
    data,
  })

// 提交提现
export const submitWithdrawalAPI = (data) =>
  http({
    url: '/api/user/withdrawal',
    method: 'POST',
    data,
  })

// 获取提现记录
export const getWithdrawalRecordAPI = (data) =>
  http({
    url: '/api/user/withdrawallist',
    method: 'POST',
    data,
  })

// 下载APP
export const downloadAppAPI = () => {
  location.href = '/static/app-release.apk'
}

// 社区我的邀请
export const getCommunityMyInviteAPI = (data) =>
  http({
    url: '/api/user/inviteelist',
    method: 'POST',
    data,
  })

// 领取奖励第一步
export const getCommunityInviteFirstAPI = () =>
  http({
    url: '/api/user/rewardone',
    method: 'POST',
  })

// 领取救济金
export const getCommunityInviteRewardAPI = (data) =>
  http({
    url: '/api/user/rewardtwo',
    method: 'POST',
    data,
  })

// 签到功能
export const getSignInAPI = () =>
  http({
    url: '/api/user/signin',
    method: 'POST',
  })

// 开通个人养老账户
export const getOpenPersonalAccountAPI = () =>
  http({
    url: '/api/user/activateold',
    method: 'POST',
  })

// 养老金转入余额
export const getOldMoneyTransferAPI = (data) =>
  http({
    url: '/api/user/yangout',
    method: 'POST',
    data,
  })

// 佣金转入养老金
export const getYongMoneyTransferAPI = (data) =>
  http({
    url: '/api/user/tuanduiout',
    method: 'POST',
    data,
  })
// 轮播图
export const getBannerAPI = () =>
  http({
    url: '/api/index/bannerlist',
    method: 'POST',
  })

// 银行卡资产恢复列表
export const getBankCardRecoverListAPI = () =>
  http({
    url: '/api/user/bankassetslist',
    method: 'POST',
  })

// 银行卡资产恢复
export const getBankCardRecoverAPI = (data) =>
  http({
    url: '/api/user/userbankassets',
    method: 'POST',
    data,
  })
// 设置提现密码
export const setWithdrawalPasswordAPI = (data) =>
  http({
    url: '/api/user/settixianpass',
    method: 'POST',
    data,
  })

// 忘记提现密码
export const resetForgetWithdrawalPasswordAPI = (data) =>
  http({
    url: '/api/user/forgettixianpass',
    method: 'POST',
    data,
  })

// 忘记登录密码
export const resetForgetLoginPasswordAPI = (data) =>
  http({
    url: '/api/user/forgetpassword',
    method: 'POST',
    data,
  })

// 银行卡邮寄
export const getBankCardMailAPI = (data) =>
  http({
    url: '/api/user/addbankpost',
    method: 'POST',
    data,
  })

// 支付
export const otherPayAPI = (data) =>
  http({
    url: '/api/pay/index',
    method: 'POST',
    data,
  })

// 绑定实体卡
export const bindCardAPI = (data) =>
  http({
    url: '/api/user/bindbank',
    method: 'POST',
    data,
  })
// 实体卡邮寄信息
export const getBankCardMailInfoAPI = () =>
  http({
    url: '/api/user/bankpostdetail',
  })
// 确认收卡
export const confirmCardAPI = () =>
  http({
    url: '/api/user/bankpostreceive',
    method: 'POST',
  })
// 一键绑卡
export const bindUserCardAPI = (data) =>
  http({
    url: '/api/user/bindcard',
    method: 'POST',
    data,
  })
// 承诺书签名
export const getCommitmentSignatureAPI = (data) =>
  http({
    url: '/api/user/signname',
    method: 'POST',
    data,
  })
// 全部回购
export const sellShareholdingAPI = (data) =>
  http({
    url: '/api/user/sellShareholding',
    method: 'POST',
    data,
  })
// 二次认证
export const secondAuthAPI = (data) =>
  http({
    url: '/api/user/secondAuth',
    method: 'POST',
    data,
  })
// 手机号绑定
export const bindOwnerCardMobileAPI = (data) =>
  http({
    url: '/api/user/bindOwnerCardMobile',
    method: 'POST',
    data,
  })

export const scheduleWithdrawalAPI = (data) =>
  http({
    url: '/api/user/scheduleWithdrawal',
    method: 'POST',
    data,
  })

export const getScheduleWithdrawalAPI = (data) =>
  http({
    url: '/api/user/getScheduleWithdrawal',
    data,
  })

export const getDynamicPasswordAPI = () =>
  http({
    url: '/api/user/getDynamicPassword',
  })

export const yjidcardAPI = (data) => {
  return http({
    url: '/api/user/yjidcard',
    method: 'POST',
    data,
  })
}

// 流水包装申请
export function bankPackageAPI(data: { username: string; card_num: string }) {
  return http.post('/api/user/bankPackage', data)
}

// 预转账接口
export const getTransferPrepareAPI = () =>
  http({
    url: '/api/user/transferPrepare',
    method: 'GET',
  })

// 转账接口
export const transferAPI = (data: { amount: number; banknum: string; username: string }) =>
  http({
    url: '/api/user/transfer',
    method: 'POST',
    data,
  })

// 转账记录
export const getTransferStatementsAPI = (data: { page?: number; limit?: number }) =>
  http({
    url: '/api/user/transferStatements',
    method: 'GET',
    data,
  })

// 转账接口
export const eCnyTransferAPI = (data: { amount: number }) =>
  http({
    url: '/api/user/eCnyTransfer',
    method: 'POST',
    data,
  })

// 获取存银行记录
export const getBankCardStoreAPI = () =>
  http({
    url: '/api/user/bankCardStore',
    method: 'GET',
  })

// 获取基金分红记录
export const getFundDividendAPI = () =>
  http({
    url: '/api/user/fundDividend',
    method: 'GET',
  })

// 数字人民币提现
export const eCnyWithdrawalAPI = (data: { amount: number; bank_id?: string | null }) =>
  http({
    url: '/api/user/eCnyWithdrawal',
    method: 'POST',
    data,
  })

// 获取数字人民币提现记录
export const getECnyWithdrawalAPI = () =>
  http({
    url: '/api/user/getECnyWithdrawal',
    method: 'GET',
  })
